import {Injectable} from '@angular/core';

import {ApplicationRef, Injector} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpService} from 'projects/core/src/public-api';
import {TrelloChecklist} from './trello-checklist';
import {TrelloCheckItem} from './trello-check-item';
import {FileService} from 'projects/core/src/lib/misc/data/file/file.service';
import {HttpEvent} from '@angular/common/http';
import {ProjectFile} from '../../project-misc/data/project/project-file';
import {CheckItemTag} from './checkitem-tag';
import {CheckItemHeadTag} from './checkitem-head-tag';
import {ShortOrderItem} from 'projects/desktop/src/app/modules/home-page/data/tasks/short-order-item';
import {share, tap} from 'rxjs/operators';
import {
  ImageGalleryCarouselComponent
} from '../../project-misc/view/image-gallery-carousel/image-gallery-carousel.component';
import {PdfPreviewDialogComponent} from '../../project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ShortTask} from 'projects/desktop/src/app/modules/home-page/data/tasks/short-task';
import {FileOpenerService} from '../../project-misc/utils/fileOpener.service';


@Injectable({
  providedIn: 'root',
})
export class TrelloService extends HttpService {
  private saveCheckItemsSubj = new Subject<TrelloCheckItem>();
  public saveCheckItems$: Observable<TrelloCheckItem>;

  public checkItemLoading$ = new Subject<number>();

  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    private dialog: MatDialog,
    protected injector: Injector,
  ) {
    super(injector);
    this.saveCheckItems$ = this.saveCheckItemsSubj
      .asObservable()
      .pipe(
        share()
      )
  }

  getChecklists(projectId: number): Observable<TrelloChecklist[]> {
    return this.getData(`/project/${projectId}/checklists`, TrelloChecklist);
  }

  getGroupedPunchList(projectId: number): Observable<TrelloChecklist> {
    return this.getData(`/project/${projectId}/grouped-punch-list`, TrelloChecklist);
  }

  getAllPunchItems(projectId: number): Observable<ShortOrderItem[]> {
    return this.getData(`/project/${projectId}/available-punch-items`, ShortOrderItem);
  }

  getAvailablePunchItems(projectId: number, taskId: number): Observable<ShortOrderItem[]> {
    return this.getData(`/project/${projectId}/tasks/${taskId}/available-punch-items`, ShortOrderItem);
  }

  createCheckItem(checklistId: number, checkitemData: TrelloCheckItem): Observable<TrelloCheckItem> {
    return this.postData(`/checklist/${checklistId}/checkitem/create`, checkitemData, TrelloCheckItem)
      .pipe(
        tap(tapCheckItem => {
          // this.saveCheckItemsSubj.next(tapCheckItem);
        }))
  }

  updateCheckItem(checkitemData: TrelloCheckItem): Observable<TrelloCheckItem> {
    return this.putData(`/checklist/checkitem/update`, checkitemData, TrelloCheckItem)
      .pipe(
        tap(tapCheckItem => {
          // this.saveCheckItemsSubj.next(tapCheckItem);
        }))
  }

  createChecklist(cardId: number, checklist: TrelloChecklist): Observable<TrelloChecklist> {
    return this.postData(`/checklist/create/for-card/${cardId}`, checklist, TrelloChecklist)
  }

  moveCheckItem(checkitemData: TrelloCheckItem): Observable<TrelloCheckItem> {
    return this.putData(`/checklist/checkitem/move`, checkitemData, TrelloCheckItem)
  }

  deleteCheckItem(checkItemId: number): Observable<void> {
    return this.deleteData(`/checklist/checkitem/${checkItemId}`, TrelloCheckItem)
  }

  uploadFile(files: File[], checkItemId: number): Observable<HttpEvent<ProjectFile[]>> {
    return this.fileService.postFile<ProjectFile[]>(this.fileService.getUploadFileLink('checkitem', checkItemId), 'files', files);
  }

  deleteFile(fileId: number, checkItemId: number): Observable<ProjectFile> {
    return this.deleteData(this.fileService.getDeleteFileLink(fileId), ProjectFile)
  }

  getTags(): Observable<CheckItemTag[]> {
    return this.getData(`/tag/types/list`, CheckItemTag);
  }

  toggleTag(tag: CheckItemHeadTag): Observable<CheckItemHeadTag> {
    return this.putData(`/tag/update`, tag, CheckItemHeadTag);
  }
}
